import { render, staticRenderFns } from "./CompanyNotificationList.vue?vue&type=template&id=41e560d3&"
import script from "./CompanyNotificationList.vue?vue&type=script&lang=js&"
export * from "./CompanyNotificationList.vue?vue&type=script&lang=js&"
import style0 from "./CompanyNotificationList.vue?vue&type=style&index=0&id=41e560d3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports